/**
 * 
 * @fileoverview GuardService
 *
 * @version 1.0
 *
 * @author Milan Gotera <milangotera@gmail.com>
 *
*/

import { Injectable } from '@angular/core';
import { CanActivate } from "@angular/router";
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class GuardService implements CanActivate {

  constructor(
    private auth: AuthService
  ){}

  canActivate(): boolean {
    return this.auth.isAuthenticated();
  }

}
